module.exports = __webpack_public_path__ + "img/map_outifled-mezzanine.26bbb5c9.jpg";